import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateAdapter } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastsContainerComponent } from '@rtr-factory/ui/toast';
import { UiLanguage, userActions, userFeature } from 'rio-core';
import { HeaderComponent } from 'rio-header';
import { tap } from 'rxjs';
import { cypressTranslationLoaded } from './cypress-helper';

@Component({
  imports: [RouterModule, TranslateModule, HeaderComponent, ToastsContainerComponent],
  providers: [TranslateService],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  store = inject(Store);
  dateAdapter = inject(DateAdapter);
  destroyRef = inject(DestroyRef);

  title = 'tio-rewrite';

  selectedLanguage$ = this.store.select(userFeature.selectUiLanguage);

  constructor() {
    cypressTranslationLoaded();
  }

  ngOnInit(): void {
    this.store.dispatch({ type: '[App] Init' });
    this.store.dispatch(userActions.loadLanguage());

    this.selectedLanguage$
      .pipe(
        tap((value: UiLanguage) => this.dateAdapter.setLocale(value)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
